import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Option } from '../models/option.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OptionService {
  private apiUrl = environment.apiUrl + environment.optionPath;

  constructor(private http: HttpClient) {}

  getOptions(): Observable<Option[]> {
    return this.http.get<Option[]>(this.apiUrl);
  }
}
